import React, { useState } from "react";

const DisbursementRecordModal = ({
  isDisbursementRecordModalOpen,
  closeDisbursementRecordModal,
  photoFile,
  fileInputFront,
  handlePhotoFileChange,
  bankName,
  setBankName,
  referenceNumber,
  setReferenceNumber,
  disbursedAt,
  loanCode,
  setDisbursedAt,
  bankAccountNumber,
  setBankAccountNumber,
  amountDisbursed,
  setAmountDisbursed,
  handleSubmitBankRecords,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  if (!isDisbursementRecordModalOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="relative bg-white shadow max-w-[64%] h-[72vh] mx-auto p-6 rounded-lsm flex flex-col">
        <h2 className="text-xl font-bold mb-4">Loan Disbursement Record</h2>
        <div className="mb-4">
          <p className="text-sm text-black">
            Enter the final transaction details to complete the disbursement
            record for audit purposes. Ensure all
          </p>
          <p className="text-sm text-black">
            information is accurate before submitting.
          </p>
        </div>

        <div className="flex items-center gap-3 mb-4">
          <div className="mb-4">
            <label className="block font-semibold">Bank</label>
            <input
              type="text"
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
              placeholder="Enter Bank Name"
              className="bg-transparent outline-none w-[404px] h-[51px] text-black border border-[#1E1E1E] bg-[#EAEAEA] rounded-md p-4"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Reference Number</label>
            <input
              type="text"
              value={referenceNumber}
              onChange={(e) => setReferenceNumber(e.target.value)}
              placeholder="Enter Reference Number"
              className="bg-transparent outline-none w-[404px] h-[51px] text-black border border-[#1E1E1E] bg-[#EAEAEA] rounded-md p-4"
            />
          </div>
        </div>

        <div className="flex items-center gap-3 mb-4">
          <div className="mb-4">
            <label className="block font-semibold">Account Number</label>
            <input
              type="text"
              value={bankAccountNumber}
              onChange={(e) => setBankAccountNumber(e.target.value)}
              placeholder="Enter Account Number"
              className="bg-transparent outline-none w-[404px] h-[51px] text-black border border-[#1E1E1E] bg-[#EAEAEA] rounded-md p-4"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Amount Disbursed</label>
            <input
              type="text"
              value={amountDisbursed}
              onChange={(e) => setAmountDisbursed(e.target.value)}
              placeholder="Enter Amount Disbursed"
              className="bg-transparent outline-none w-[404px] h-[51px] text-black border border-[#1E1E1E] bg-[#EAEAEA] rounded-md p-4"
            />
          </div>
        </div>

        <div className="flex items-center gap-3 mb-4">
          <div className="mb-4">
            <label className="block font-semibold">Date</label>
            <input
              type="date"
              value={disbursedAt}
              onChange={(e) => setDisbursedAt(e.target.value)}
              className="bg-transparent outline-none w-[404px] h-[51px] text-black border border-[#1E1E1E] bg-[#EAEAEA] rounded-md p-4"
            />
          </div>

          <div className="">
            <label className="block font-semibold">Upload File</label>
            <div
              onClick={() => fileInputFront.current?.click()}
              className="w-[404px] max-w-md h-[85px] rounded-[5px] bg-[#EAEAEA] flex items-center justify-center flex-col cursor-pointer"
            >
              <svg
                width="45"
                height="45"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.5625 29.2069V12.9881L17.1938 17.3569L15.8663 16.0106L22.5 9.375L29.1356 16.0106L27.8081 17.3588L23.4375 12.9881V29.2069H21.5625ZM12.405 35.625C11.5413 35.625 10.8206 35.3363 10.2431 34.7588C9.66562 34.1812 9.37625 33.46 9.375 32.595V28.0519H11.25V32.595C11.25 32.8838 11.37 33.1488 11.61 33.39C11.85 33.6313 12.1144 33.7512 12.4031 33.75H32.5969C32.8844 33.75 33.1488 33.63 33.39 33.39C33.6313 33.15 33.7512 32.885 33.75 32.595V28.0519H35.625V32.595C35.625 33.4588 35.3363 34.1794 34.7588 34.7569C34.1812 35.3344 33.46 35.6238 32.595 35.625H12.405Z"
                  fill="black"
                />
              </svg>
              <input
                type="file"
                ref={fileInputFront}
                onChange={handlePhotoFileChange}
                accept=".csv, .pdf, .docx, .doc, .jpeg, .png"
                style={{ display: "none" }}
              />
              <p className="text-[#005C53B8] text-16 text-center">
                {!photoFile ? (
                  <>
                    Drag and Drop or{" "}
                    <span
                      style={{ color: "#06B217", textDecoration: "underline" }}
                    >
                      Choose file
                    </span>{" "}
                    here
                  </>
                ) : (
                  photoFile.name
                )}
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col flex-grow justify-end">
          <div className="flex items-center gap-2 mb-4">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
            />
            <label>
              I confirm that the funds have been disbursed, and the details
              provided are accurate for record-keeping.
            </label>
          </div>

          <div className="flex justify-between mb-7">
            <button
              onClick={closeDisbursementRecordModal}
              className="bg-[#8ED6A8] px-4 py-2 rounded w-[243px] h-[51px] text-white"
            >
              Back
            </button>
            <button
              disabled={!isChecked}
              onClick={() =>
                handleSubmitBankRecords(
                  loanCode,
                  bankName,
                  bankAccountNumber,
                  referenceNumber,
                  amountDisbursed,
                  disbursedAt,
                  photoFile
                )
              }
              className={`px-4 py-2 rounded w-[243px] h-[51px] ${
                isChecked
                  ? "bg-[#005C53] text-white"
                  : "bg-[#C9C9C9] text-gray-700"
              }`}
            >
              Finish
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisbursementRecordModal;
